module.exports = __webpack_public_path__ + "img/avatar2.a3324033.png";